export default function Loading() {
    return (
        <div className="loader-container">
            <div className="spinner"></div>
            <p>Analyzing market conditions...</p>
            <span className="subtext">
                First load may take some time (server waking up)
            </span>
        </div>
    );
}